import { useQuery } from '@tanstack/react-query';
import { fetchCaseCustomFields } from '../../api/integrations';
import type { CaseCustomFieldsResponse } from '../../api/integrations';

export const caseCustomFieldsQueryKey = (orgId: string, productId: string) =>
  ['case-custom-fields', orgId, productId] as const;

export function useCaseCustomFields(orgId: string, productId: string) {
  return useQuery<CaseCustomFieldsResponse>({
    queryKey: caseCustomFieldsQueryKey(orgId, productId),
    queryFn: () => fetchCaseCustomFields(orgId, productId),
    enabled: !!orgId && !!productId,
  });
}
